export const NAV = {
  logo: "nav-logo",
  linkProducts: "nav-link-products",
  linkEligibility: "nav-link-eligibility",
  linkWhy: "nav-link-why",
  linkFaq: "nav-link-faq",
  ctaApply: "nav-cta-apply",
};

export const HERO = {
  section: "hero-section",
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
  iframe: "afn-lead-iframe",
};

export const PRODUCTS = {
  section: "products-section",
  card: (key) => `product-card-${key}`,
};

export const ELIGIBILITY = {
  section: "eligibility-section",
  cta: "eligibility-cta",
};

export const WHY = {
  section: "why-zentrix-section",
  cta: "why-zentrix-cta",
};

export const STATS = {
  section: "stats-section",
};

export const FAQ = {
  section: "faq-section",
  item: (key) => `faq-item-${key}`,
};

export const FOOTER = {
  section: "footer-section",
  ctaApply: "footer-cta-apply",
};

export const STICKY = {
  apply: "sticky-mobile-apply",
};
